// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-sidebar {
  width: 280px;
  height: 100vh;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.dashboard-sidebar.collapsed {
  width: 80px;
}

/* Sidebar Header */
.sidebar-header {
  padding: 1.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 80px;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.brand-icon {
  font-size: 1.5rem;
  color: #3b82f6;
}

.brand-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.sidebar-toggle-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.sidebar-toggle-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

/* Navigation */
.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
  overflow-y: auto;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item-container {
  margin-bottom: 0.25rem;
}

.nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  position: relative;
  border-radius: 0;
}

.nav-item:hover {
  background: #f8fafc;
  color: #374151;
}

.nav-item.active {
  background: #eff6ff;
  color: #2563eb;
  border-right: 3px solid #2563eb;
}

.nav-item.has-submenu {
  justify-content: space-between;
}

.nav-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-label {
  flex: 1 1;
  font-size: 0.9rem;
  font-weight: 500;
}

.nav-badge {
  background: #ef4444;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.125rem 0.5rem;
  border-radius: 12px;
  min-width: 1.25rem;
  text-align: center;
}

.nav-arrow {
  transition: transform 0.2s;
  color: #9ca3af;
}

.nav-arrow.expanded {
  transform: rotate(180deg);
}

/* Sub Navigation */
.sub-nav {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f8fafc;
}

.sub-nav.expanded {
  max-height: 200px;
}

.sub-nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem 0.5rem 3rem;
  border: none;
  background: none;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  font-size: 0.85rem;
}

.sub-nav-item:hover {
  background: #e2e8f0;
  color: #374151;
}

.sub-nav-item.active {
  background: #dbeafe;
  color: #1d4ed8;
}

.sub-nav-icon {
  flex-shrink: 0;
}

.sub-nav-label {
  font-weight: 500;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid #e2e8f0;
  margin-top: auto;
}

.sidebar-footer-content {
  text-align: center;
}

.footer-info {
  color: #9ca3af;
  font-size: 0.75rem;
}

.footer-version {
  font-weight: 500;
}

/* Collapsed State */
.dashboard-sidebar.collapsed .sidebar-brand,
.dashboard-sidebar.collapsed .nav-label,
.dashboard-sidebar.collapsed .nav-badge,
.dashboard-sidebar.collapsed .nav-arrow,
.dashboard-sidebar.collapsed .sub-nav,
.dashboard-sidebar.collapsed .sidebar-footer-content {
  display: none;
}

.dashboard-sidebar.collapsed .nav-item {
  justify-content: center;
  padding: 0.75rem;
}

.dashboard-sidebar.collapsed .sidebar-header {
  justify-content: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-sidebar {
    transform: translateX(-100%);
  }

  .dashboard-sidebar.collapsed {
    transform: translateX(0);
    width: 80px;
  }
}

@media (max-width: 768px) {
  .dashboard-sidebar {
    width: 100%;
    transform: translateX(-100%);
  }

  .dashboard-sidebar.collapsed {
    transform: translateX(0);
    width: 280px;
  }
}

/* Scrollbar Styling */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardSidebar/DashboardSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;;;;;EAME,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".dashboard-sidebar {\n  width: 280px;\n  height: 100vh;\n  background: #ffffff;\n  border-right: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-sidebar.collapsed {\n  width: 80px;\n}\n\n/* Sidebar Header */\n.sidebar-header {\n  padding: 1.5rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 80px;\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.brand-icon {\n  font-size: 1.5rem;\n  color: #3b82f6;\n}\n\n.brand-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.sidebar-toggle-btn {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n}\n\n.sidebar-toggle-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Navigation */\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n  overflow-y: auto;\n}\n\n.nav-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-item-container {\n  margin-bottom: 0.25rem;\n}\n\n.nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n  position: relative;\n  border-radius: 0;\n}\n\n.nav-item:hover {\n  background: #f8fafc;\n  color: #374151;\n}\n\n.nav-item.active {\n  background: #eff6ff;\n  color: #2563eb;\n  border-right: 3px solid #2563eb;\n}\n\n.nav-item.has-submenu {\n  justify-content: space-between;\n}\n\n.nav-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-label {\n  flex: 1;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.nav-badge {\n  background: #ef4444;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.125rem 0.5rem;\n  border-radius: 12px;\n  min-width: 1.25rem;\n  text-align: center;\n}\n\n.nav-arrow {\n  transition: transform 0.2s;\n  color: #9ca3af;\n}\n\n.nav-arrow.expanded {\n  transform: rotate(180deg);\n}\n\n/* Sub Navigation */\n.sub-nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  background: #f8fafc;\n}\n\n.sub-nav.expanded {\n  max-height: 200px;\n}\n\n.sub-nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 1rem 0.5rem 3rem;\n  border: none;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n  font-size: 0.85rem;\n}\n\n.sub-nav-item:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.sub-nav-item.active {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.sub-nav-icon {\n  flex-shrink: 0;\n}\n\n.sub-nav-label {\n  font-weight: 500;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 1rem;\n  border-top: 1px solid #e2e8f0;\n  margin-top: auto;\n}\n\n.sidebar-footer-content {\n  text-align: center;\n}\n\n.footer-info {\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n.footer-version {\n  font-weight: 500;\n}\n\n/* Collapsed State */\n.dashboard-sidebar.collapsed .sidebar-brand,\n.dashboard-sidebar.collapsed .nav-label,\n.dashboard-sidebar.collapsed .nav-badge,\n.dashboard-sidebar.collapsed .nav-arrow,\n.dashboard-sidebar.collapsed .sub-nav,\n.dashboard-sidebar.collapsed .sidebar-footer-content {\n  display: none;\n}\n\n.dashboard-sidebar.collapsed .nav-item {\n  justify-content: center;\n  padding: 0.75rem;\n}\n\n.dashboard-sidebar.collapsed .sidebar-header {\n  justify-content: center;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .dashboard-sidebar {\n    transform: translateX(-100%);\n  }\n\n  .dashboard-sidebar.collapsed {\n    transform: translateX(0);\n    width: 80px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-sidebar {\n    width: 100%;\n    transform: translateX(-100%);\n  }\n\n  .dashboard-sidebar.collapsed {\n    transform: translateX(0);\n    width: 280px;\n  }\n}\n\n/* Scrollbar Styling */\n.sidebar-nav::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 2px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
